<template>
    <div class="container">
        <header class="header">
            <nav class="breadcrumb">
                <router-link to="/companyPolicies">{{$t('confidentialityPolicy.header.breadcrumb.companyPoliciesLink')}}</router-link>
                <span>{{$t('confidentialityPolicy.header.breadcrumb.readTime')}}</span>
            </nav>
            <h1>{{$t('confidentialityPolicy.header.title')}}</h1>
            
            <!-- <div class="stats">
                <span>👁️ 15,754</span>
                <span>💖</span>
                <span>🔗</span> 
            </div> -->
        </header>
    
        <main class="main-content">
            <div class="articles">
                <article class="content">
                    <h2>{{$t('confidentialityPolicy.mainContent.articles[0].title')}}</h2>
                    <p>{{$t('confidentialityPolicy.mainContent.articles[0].content')}}</p>
                </article>
                
                <article class="content">
                    <h2>{{$t('confidentialityPolicy.mainContent.articles[1].title')}}</h2>
                    <p>{{$t('confidentialityPolicy.mainContent.articles[1].content')}}</p>
                </article>
    
                <article class="content">
                    <h2>{{$t('confidentialityPolicy.mainContent.articles[2].title')}}</h2>
                    
                    <ul>
                        <li><span>{{$t('confidentialityPolicy.mainContent.articles[2].list[0].term')}}:</span> {{$t('confidentialityPolicy.mainContent.articles[2].list[0].text')}}<ul>
                            <li>{{$t('confidentialityPolicy.mainContent.articles[2].list[0].details[0]')}}</li>
                            
                            <li>{{$t('confidentialityPolicy.mainContent.articles[2].list[0].details[1]')}}</li>
                            <li>{{$t('confidentialityPolicy.mainContent.articles[2].list[0].details[2]')}}</li>
                            <li>{{$t('confidentialityPolicy.mainContent.articles[2].list[0].details[3]')}}</li>
                        </ul>
                        </li>
                        <li><span>{{$t('confidentialityPolicy.mainContent.articles[2].list[1].term')}}:</span> {{$t('confidentialityPolicy.mainContent.articles[2].list[1].text')}}<ul>
                            <li>{{$t('confidentialityPolicy.mainContent.articles[2].list[1].details[0]')}}</li>
                            <li>{{$t('confidentialityPolicy.mainContent.articles[2].list[1].details[1]')}}</li>
                            <li>{{$t('confidentialityPolicy.mainContent.articles[2].list[1].details[2]')}}</li>
                        </ul>
                        </li>
                    </ul>
                    
                </article>
                <article class="content">
                    <h2>{{$t('confidentialityPolicy.mainContent.articles[3].title')}}</h2>
                    
                    <ul>
                        <li><span>{{$t('confidentialityPolicy.mainContent.articles[3].list[0].term')}}:</span> {{$t('confidentialityPolicy.mainContent.articles[3].list[0].details[0]')}}</li>
                        <li><span>{{$t('confidentialityPolicy.mainContent.articles[3].list[1].term')}}:</span>{{$t('confidentialityPolicy.mainContent.articles[3].list[1].text')}}
                        <ul>
                            <li>{{$t('confidentialityPolicy.mainContent.articles[3].list[1].details[0]')}}</li>
                            <li>{{$t('confidentialityPolicy.mainContent.articles[3].list[1].details[1]')}}</li>
                            <li>{{$t('confidentialityPolicy.mainContent.articles[3].list[1].details[2]')}}</li>
                            <li>{{$t('confidentialityPolicy.mainContent.articles[3].list[1].details[3]')}}</li>
                        </ul>
                        
                        </li>
                        <li><span>{{$t('confidentialityPolicy.mainContent.articles[3].list[2].term')}}:</span>{{$t('confidentialityPolicy.mainContent.articles[3].list[2].text')}} <ul>
                            <li>{{$t('confidentialityPolicy.mainContent.articles[3].list[2].details[0]')}}</li>
                            <li>{{$t('confidentialityPolicy.mainContent.articles[3].list[2].details[1]')}}</li>
                        </ul></li>
                    </ul>
                    
                </article>
    
                <article class="content">
                    <h2>{{$t('confidentialityPolicy.mainContent.articles[4].title')}}</h2>
                    <ul>
                        <li><span>{{$t('confidentialityPolicy.mainContent.articles[4].list[0].term')}}:</span> {{$t('confidentialityPolicy.mainContent.articles[4].list[0].details[0]')}}</li>
                        <li><span>{{$t('confidentialityPolicy.mainContent.articles[4].list[1].term')}}:</span> {{$t('confidentialityPolicy.mainContent.articles[4].list[1].details[0]')}}</li>
                        <li><span>{{$t('confidentialityPolicy.mainContent.articles[4].list[2].term')}}:</span> {{$t('confidentialityPolicy.mainContent.articles[4].list[2].details[0]')}}</li>
                    </ul>
                    
                </article>
    
                <article class="content">
                    <h2>{{$t('confidentialityPolicy.mainContent.articles[5].title')}}</h2>
                    <ul>
                        <li><span>{{$t('confidentialityPolicy.mainContent.articles[5].list[0].term')}}:</span>{{$t('confidentialityPolicy.mainContent.articles[5].list[0].text')}} <ul>
                            <li>{{$t('confidentialityPolicy.mainContent.articles[5].list[0].details[0]')}}</li>
                            <li>{{$t('confidentialityPolicy.mainContent.articles[5].list[0].details[1]')}}</li>
                            <li>{{$t('confidentialityPolicy.mainContent.articles[5].list[0].details[2]')}}</li>

                        </ul>
                        </li>
                        <li><span>{{$t('confidentialityPolicy.mainContent.articles[5].list[1].term')}}:</span> {{$t('confidentialityPolicy.mainContent.articles[5].list[1].details[0]')}}</li>
                        <li><span>{{$t('confidentialityPolicy.mainContent.articles[5].list[2].term')}}:</span> {{$t('confidentialityPolicy.mainContent.articles[5].list[2].details[0]')}}</li>
                    </ul>
                    
                </article>
    
                <article class="content">
                    <h2>{{$t('confidentialityPolicy.mainContent.articles[6].title')}}</h2>
                    <ul>
                        <li><span>{{$t('confidentialityPolicy.mainContent.articles[6].list[0].term')}}:</span> {{$t('confidentialityPolicy.mainContent.articles[6].list[0].details[0]')}}<ul>
                            <li>{{$t('confidentialityPolicy.mainContent.articles[6].list[0].details[1]')}}</li>
                            <li>{{$t('confidentialityPolicy.mainContent.articles[6].list[0].details[2]')}}</li>
                        </ul>
                        </li>
                        <li><span>{{$t('confidentialityPolicy.mainContent.articles[6].list[1].term')}}:</span> {{$t('confidentialityPolicy.mainContent.articles[6].list[1].details[0]')}}</li>
                    </ul>
                    
                </article>
    
                <article class="content">
                    <h2>{{$t('confidentialityPolicy.mainContent.articles[7].title')}}</h2>
                    <ul>
                        <li><span>{{$t('confidentialityPolicy.mainContent.articles[7].list[0].term')}}:</span> {{$t('confidentialityPolicy.mainContent.articles[7].list[0].details[0]')}}<ul>
                            <li>{{$t('confidentialityPolicy.mainContent.articles[7].list[0].details[1]')}}</li>
                            <li>{{$t('confidentialityPolicy.mainContent.articles[7].list[0].details[2]')}}</li>
                        </ul>
                        </li>
                        <li><span>{{$t('confidentialityPolicy.mainContent.articles[7].list[1].term')}}:</span> {{$t('confidentialityPolicy.mainContent.articles[7].list[1].details[0]')}}</li>
                    </ul>
                    
                </article>
    
                <article class="content">
                    <h2>{{$t('confidentialityPolicy.mainContent.articles[8].title')}}</h2>

                    <ul>
                        <li>
                            <span>{{$t('confidentialityPolicy.mainContent.articles[8].list[0].term')}}: </span>{{$t('confidentialityPolicy.mainContent.articles[8].list[0].details[0]')}}
                            <ul>
                                <li>{{$t('confidentialityPolicy.mainContent.articles[8].list[0].details[1]')}}</li>
                                <li>{{$t('confidentialityPolicy.mainContent.articles[8].list[0].details[2]')}}</li>
                                <li>{{$t('confidentialityPolicy.mainContent.articles[8].list[0].details[3]')}}</li>

                            </ul>
                        </li>
                        <li>
                            <span>{{$t('confidentialityPolicy.mainContent.articles[8].list[1].term')}}: </span>{{$t('confidentialityPolicy.mainContent.articles[8].list[1].details[0]')}}
                            <ul>
                                <li>{{$t('confidentialityPolicy.mainContent.articles[8].list[1].details[1]')}}</li>
                                <li>{{$t('confidentialityPolicy.mainContent.articles[8].list[1].details[2]')}}</li>

                            </ul>
                        </li>
                    </ul>
                </article>

                <article class="content">
                    <h2>{{$t('confidentialityPolicy.mainContent.articles[9].title')}}</h2>

                    <ul>
                        <li>
                            <span>{{$t('confidentialityPolicy.mainContent.articles[9].list[0].term')}}: </span>{{$t('confidentialityPolicy.mainContent.articles[9].list[0].details[0]')}}
                            <ul>
                                <li>{{$t('confidentialityPolicy.mainContent.articles[9].list[0].details[1]')}}</li>
                                <li>{{$t('confidentialityPolicy.mainContent.articles[9].list[0].details[2]')}}</li>
                                <li>{{$t('confidentialityPolicy.mainContent.articles[9].list[0].details[3]')}}</li>

                            </ul>
                        </li>
                        <li>
                            <span>{{$t('confidentialityPolicy.mainContent.articles[9].list[1].term')}}: </span>{{$t('confidentialityPolicy.mainContent.articles[9].list[1].details[0]')}}
                            <ul>
                                <li>{{$t('confidentialityPolicy.mainContent.articles[9].list[1].details[1]')}}</li>
                                <li>{{$t('confidentialityPolicy.mainContent.articles[9].list[1].details[2]')}}</li>

                            </ul>
                        </li>
                    </ul>
                </article>

                <article class="content">
                    <h2>{{$t('confidentialityPolicy.mainContent.articles[10].title')}}</h2>
                    <p>{{$t('confidentialityPolicy.mainContent.articles[10].content')}}</p>
                </article>
            </div>
    
            <!-- <aside class="sidebar">
                <a class="download-btn" href="#">{{$t('confidentialityPolicy.sidebar.downloadButton')}}</a>
            </aside> -->
        </main>
    </div>
    
</template>

<script setup>

</script>

<style  scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family:"poppins";

}

body {
    background-color: #f8f9fa;
    color: #333;
}
.alpha{
    list-style-type:lower-latin;
}
.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
}
.subList{
    margin:0px 40px;
}
.header {
    text-align: center;
    padding: 40px 20px;
    background-color: #f0f4ff;
    margin-bottom: 40px;
}

.breadcrumb {
    font-size: 0.9rem;
    color: #5f6368;
    margin-bottom: 20px;
}

.breadcrumb a {
    color: #0073e6;
    text-decoration: none;
}

.breadcrumb a:hover {
    text-decoration: underline;
}
.articles{
    width:100vw;
}
article{
    width:100%;
    margin: 50px 0;

}
span{
    font-weight:bold;
}
.content>ul>li>ul>li{
    margin:20px 40px;
}
h1 {
    font-size: 2.5rem;
    color: #333;
    margin-bottom: 10px;
    font-family:"poppins";
    font-weight:700;
}

.subheading {
    font-size: 1.2rem;
    color: #666;
    max-width: 800px;
    margin: 0 auto 20px;
}

.stats {
    font-size: 0.9rem;
    color: #777;
    display: flex;
    justify-content: center;
    gap: 15px;
}

.main-content {
    display: flex;
}

.content {
    width: 95%;
    line-height: 1.6;
    text-align:left;
}

.content h2 {
    font-size: 1.9rem;
    margin-bottom: 20px;
    font-family:"poppins";
    font-weight:700;
}
.content p,.content li{
    font-size:19px;
    color:#333E49;
    font-weight: 400;
    margin:20px 0;

}

.sidebar {
    width: 30%;
    background-color: #ffffff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    max-height: 50px;

}

.download-btn {
    display: inline-block;
    background-color: #00bfa5;
    color: white;
    text-align: center;
    padding: 10px 20px;
    text-decoration: none;
    font-size: 1rem;
    border-radius: 4px;
    margin-bottom: 30px;
}

.download-btn:hover {
    background-color: #009688;
}

.sidebar h3 {
    font-size: 1.2rem;
    margin-bottom: 15px;
}

.sidebar ul {
    list-style: none;
    margin-bottom: 20px;
}

.sidebar ul li {
    margin-bottom: 10px;
}

.sidebar ul li a {
    text-decoration: none;
    color: #0073e6;
}

.sidebar ul li a:hover {
    text-decoration: underline;
}

/* Responsive Design */
@media (max-width: 768px) {
    .main-content {
        flex-direction: column;
    }

    .content, .sidebar {
        width: 100%;
    }

    .header {
        padding: 20px 10px;
    }
}

</style>